import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ProposalService } from 'src/app/services/proposal/proposal.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { MainService } from 'src/app/services/main-service.service';
import { ToasterService } from 'src/app/services/toaster.service';

@Component({
  selector: 'app-write-to-us',
  templateUrl: './write-to-us.component.html',
  styleUrls: ['./write-to-us.component.scss']
})
export class WriteToUsComponent implements OnInit {
  public data;
  planInfo: any;
  mask: any = [/[1-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  messageDesc: any;
  response: any = '';
  payment_process_data: any;
  constructor(
    public modalRef: BsModalRef,
    public proposal: ProposalService,
    public http: HttpClient,
    public mainService: MainService,
    private _toaster: ToasterService
  ) { }

  ngOnInit() {
    if (localStorage.getItem('payment_process_data')) {
      this.payment_process_data = JSON.parse(localStorage.getItem('payment_process_data'));
      this.payment_process_data.name = this.payment_process_data.name ? this.payment_process_data.name : '';
      this.payment_process_data.patient_email = this.payment_process_data.patient_email ? this.payment_process_data.patient_email : '';
      if (this.payment_process_data.patient_mobile && this.payment_process_data.patient_mobile.split('-').length > 1) {
        this.payment_process_data.patient_mobile = this.payment_process_data.patient_mobile.split('-')[1]
      }
    } else if(localStorage.getItem('pay_recurring_data')){
      this.payment_process_data = JSON.parse(localStorage.getItem('pay_recurring_data'));
      this.payment_process_data.name = this.payment_process_data.title?(this.payment_process_data.title+" "+this.payment_process_data.patient_first_name+" "+this.payment_process_data.patient_last_name):(this.payment_process_data.patient_first_name+" "+this.payment_process_data.patient_last_name)
      this.payment_process_data.patient_email = this.payment_process_data.patient_email ? this.payment_process_data.patient_email : '';
      if (this.payment_process_data.patient_mobile && this.payment_process_data.patient_mobile.split('-').length > 1) {
        this.payment_process_data.patient_mobile = this.payment_process_data.patient_mobile.split('-')[1]
      }
    } else {
      this.payment_process_data = {};
    }

    this.planInfo = this.data;
    this.planInfo.patient_name = this.planInfo.patient_first_name ? this.planInfo.patient_first_name + ' ' + this.planInfo.patient_last_name : '';
    if (this.planInfo.patient_mobile && this.planInfo.patient_mobile.split('-').length > 1) {
      this.planInfo.patient_mobile = this.planInfo.patient_mobile.split('-')[1]
    }
  }

  writeToUs(form: any) {
    if (!this.messageDesc || !this.messageDesc.trim()) {
      this._toaster.message('Please enter a valid message', 2);
      return;
    }
    let params = {
      type: 2,
      name: this.planInfo.patient_name || this.payment_process_data.name,
      phone: this.planInfo.patient_mobile ? this.planInfo.patient_mobile.replace(/[^0-9]/g, '') : this.payment_process_data.patient_mobile ?  this.payment_process_data.patient_mobile.replace(/[^0-9]/g, '') : '',
      src_url: 'Inquiry made from Customer Split Panel ' + window.location.href,
      message: this.messageDesc.trim(),
      specialty: 'N.A.',
      zip: 'N.A.',
      address: 'N.A.',
      email: this.planInfo.patient_email || this.payment_process_data.patient_email,
    };
    if(form.invalid){
      return false;
    }
    this.mainService.setLoader(true);
    this.http.post(environment.business_url + 'add_wp_contact_query', params)
      .subscribe((data: any) => {
        this.mainService.setLoader(false);
        this.response = data;
      }, (error: any) => {
        this.mainService.setLoader(false);
        this.response = '';
      })
  }
}
